export const POSTURE_TEMPLATES_LIST_PATH = '/secure/posture-templates'
export const POSTURE_TEMPLATE_PATH = '/secure/posture-templates/:templateId'

export const SECURE_POSTURE_TAB_KEYS = {
  AUDIT: 'audit',
  PROTECT: 'protect',
}
export const SECURE_POSTURE_PATH = '/secure/security-posture/:companySelectorId?'
export const SECURE_POSTURE_COMPANY_PATH = '/secure/security-posture/:companySelectorId?/:tabKey?'
export const SECURE_POSTURE_CHECK_PATH = `/secure/security-posture/:companySelectorId/${SECURE_POSTURE_TAB_KEYS.AUDIT}/:securityCheckType`
export const SECURE_COMPLIANCE_PATH = '/secure/compliance/:companySelectorId?'
export const SECURE_COMPLIANCE_AUDIT_PATH = '/secure/compliance/audit/:companySelectorId?'
export const SECURE_COMPLIANCE_ASSESSMENTS_PATH = '/secure/compliance/assessments/:companySelectorId?'
export const SECURE_COMPLIANCE_ASSESSMENT_PATH = '/secure/compliance/assessment/:assessmentId?'

export const SECURE_ALERTS_PATH = '/secure/alerts/:companySelectorId?'

export const INTEGRATIONS_PATH = '/integrations/:companySelectorId?'

export const SECURE_POLICIES_PATH = '/secure/policy-management/policies/:companySelectorId?' // This will be for Policy Management instead
export const SECURE_POLICIES_ROOT_PATH = '/secure/policy-management/policies' // This will be for policy management instead

export const POLICY_TEMPLATE_LIST_PATH = '/secure/policy-management/templates/:templateId' // This will be for Policy Templates
export const POLICY_TEMPLATE_PATH = '/secure/policy-management/templates' // This will be for Policy Templates

export const POLICY_MANAGEMENT_NAMED_LOCATIONS_PATH = '/secure/policy-management/named-locations/:companySelectorId?'

export const ENGAGE_ACTIONS_PATH = '/engage/user-management/:companySelectorId?'
export const ENGAGE_ACTION_LOG_PATH = '/engage/action-log/:companySelectorId?'
export const ENGAGE_DISTRIBUTION_LISTS_PATH = '/engage/distribution-lists/:companySelectorId?'

export const EMPLOYEES_PATH = '/employees/:companySelectorId?'

export const DEFENDER_POLICIES_ROOT_PATH = '/secure/defender/policies'
export const DEFENDER_POLICIES_PATH = '/secure/defender/policies/:companySelectorId?'

export const DEFENDER_TEMPLATES_PATH = '/secure/defender/templates'

export const INTUNE_DEVICE_POLICIES_ROOT_PATH = '/secure/intune/device-management/policies'
export const INTUNE_DEVICE_POLICIES_PATH = '/secure/intune/device-management/policies/:companySelectorId?'
export const INTUNE_DEVICE_TEMPLATES_PATH = '/secure/intune/device-management/templates'

export const INTUNE_DEPLOYMENT_PROFILES_ROOT_PATH = '/secure/intune/onboarding/deployment-profiles'
export const INTUNE_DEPLOYMENT_PROFILES_PATH = '/secure/intune/onboarding/deployment-profiles/:companySelectorId?'
export const INTUNE_DEPLOYMENT_PROFILES_TEMPLATES_PATH = '/secure/intune/onboarding/templates'

export const GROUPS_ROOT_PATH = '/secure/entra-id/groups'
export const GROUPS_PATH = '/secure/entra-id/groups/:companySelectorId?'
export const GROUPS_TEMPLATES_PATH = '/secure/entra-id/groups-templates'

export const DISCOVER_ROOT_PATH = '/discovery'
export const DISCOVER_PATH = '/discovery/:companySelectorId?'
export const DISCOVER_RISK_PATH = '/discover/risk/:companySelectorId?'
export const DISCOVER_DATA_PATH = '/discover/data/:companySelectorId?'
export const DISCOVER_APPLICATIONS_PATH = '/discover/applications/:companySelectorId?'

export const REPORTS_MFA_PATH = '/reports/mfa/:companySelectorId?'
export const REPORTS_THREATS_PATH = '/reports/threats/:companySelectorId?'
export const REPORTS_SUMMARY_PATH = '/reports/summary/:companySelectorId?'
export const REPORTS_LICENSING_PATH = '/reports/licensing/:companySelectorId?'
export const REPORTS_SCHEDULED_PATH = '/scheduled-reports/:companySelectorId?'

export const COMPANIES_PATH = '/companies'
export const COMPANIES_COLLECTIONS_PATH = '/company-collections'
